import classNames from 'classnames'
import React from 'react'
import {AccessibilityMode} from '../accessibility-mode'
import {Footer} from '../footer'
import {Plan} from '../plan'
import {TicketDescription} from '../ticket-description'
import {Tickets} from '../tickets'
import {classes} from './mobile.st.css'
import {MobileProps} from './index'

export const Mobile = ({
  placesInBasket,
  selectedPlace,
  onRemoveClick,
  onCheckoutClick,
  onPlaceClick,
  onCloseClick,
  showAccessibilityMode,
  placesInBasketCount,
  descriptionPlace,
  selectSeatForDescription,
  showDescription,
  setShowMobileBasket,
  showMobileBasket,
}: MobileProps) => {
  return (
    <div className={classNames(classes.container, {[classes.listContainer]: showAccessibilityMode})}>
      <Tickets
        placesInBasketCount={placesInBasketCount}
        showAccessibilityMode={showAccessibilityMode}
        placesInBasket={placesInBasket}
        show={showMobileBasket}
        onBackClick={() => setShowMobileBasket(false)}
        onRemoveClick={onRemoveClick}
        onCheckoutClick={onCheckoutClick}
        onTicketMoreInfoClick={selectSeatForDescription}
        chooseSeatMode={false}
        chooseMultipleSeatsMode={false}
      />
      <TicketDescription
        show={showDescription}
        place={descriptionPlace}
        onClose={() => selectSeatForDescription(null)}
      />
      {showAccessibilityMode ? (
        <AccessibilityMode onFooterButtonClick={() => setShowMobileBasket(true)} />
      ) : (
        <>
          <Plan onPlaceClick={onPlaceClick} forcedPopover={null} />
          <Footer
            withoutBreakdown={true}
            selectedPlace={selectedPlace}
            inDrawer={true}
            onCloseClick={onCloseClick}
            onCheckoutClick={() => setShowMobileBasket(true)}
          />
        </>
      )}
    </div>
  )
}
